module.exports = __webpack_public_path__ + "29033f3dadfb37934624dc6d3b12fee2.fbx";